export default "__VITE_ASSET__BR79e4yd__"